const c = {
  name: "Pizza",
  dimensions: { width: 39, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 39.4 40" style="enable-background:new 0 0 39.4 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M19.7,16c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4c0,2.2-1.8,4-4,4C21.5,20,19.7,18.2,19.7,16z M23.7,14
			c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2C25.7,14.9,24.8,14,23.7,14z"/>
		<path class="st0" d="M15.7,17.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C14.4,16.7,15,17.3,15.7,17.3
			z"/>
		<path class="st0" d="M24.9,23c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C24.4,21.8,24.9,22.3,24.9,23z"
			/>
		<path class="st0" d="M15.7,12.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.3-1.2-1.3c-0.7,0-1.2,0.6-1.2,1.3C14.4,11.7,15,12.3,15.7,12.3
			z"/>
		<path class="st0" d="M12.9,14c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C12.4,12.8,12.9,13.3,12.9,14z"
			/>
		<path class="st0" d="M13.7,29.5L11.2,25l0,0l-0.3-0.5l0,0L0,5.3l0.9-0.5C6.5,1.7,12.9,0,19.7,0c6.8,0,13.2,1.7,18.8,4.8l0.9,0.5
			L19.7,40L13.7,29.5z M2.7,6.1l1.5,2.6C8.9,6.3,14.1,5,19.7,5s10.8,1.3,15.5,3.7l1.5-2.6C31.6,3.5,25.8,2,19.7,2
			C13.6,2,7.8,3.5,2.7,6.1z M34.2,10.5C29.8,8.2,24.9,7,19.7,7C14.5,7,9.6,8.2,5.2,10.5l7,12.4c0.7-0.5,1.5-0.8,2.5-0.8
			c2.2,0,4,1.8,4,4c0,1.7-1.1,3.1-2.5,3.7l3.5,6.2L34.2,10.5z M15.2,27.9c0.9-0.2,1.5-1,1.5-1.9c0-1.1-0.9-2-2-2
			c-0.6,0-1.1,0.2-1.4,0.6L15.2,27.9z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Pizza
};
